import type { ReactNode } from 'react';

export function Kbd({ children }: { children: ReactNode }) {
  return <kbd className="rounded-ctl border border-line border-b-2 bg-panel px-1 py-0.5 font-mono text-[10.5px] text-muted">{children}</kbd>;
}
